import Axios from "axios";

class CommonService {
  async getRegion() {
    return Axios.get('regions');
  }

  async getCurrentUser(){
    return Axios.get('user/current');
  }

  async getShiftHeaders(){
    return Axios.get('shift-header/dates/15');
  }

}

export default new CommonService();